import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import dedent from 'dedent';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';

const McmPackageEssentialPlus: TenantPackageConfig<McmOrderContext> = {
  id: 'essentialp',
  name: 'Essential Plus',
  performables: [
    McmPhotoConfig,
    McmVirtualConfig,
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.VIDEO_PHOTO
      },
    },
  ],
  eligible: ({ buyer, parent }) => !Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '',
  amount: '79.95',
};

export default McmPackageEssentialPlus;
